{
  "SET_NEW_PASSWORD": {
    "TITLE": "Postavi novu lozinku",
    "PASSWORD": {
      "LABEL": "Lozinka",
      "PLACEHOLDER": "Lozinka",
      "ERROR": "Lozinka je prekratka."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Potvrdi lozinku",
      "PLACEHOLDER": "Potvrdi lozinku",
      "ERROR": "Lozinke se ne poklapaju."
    },
    "API": {
      "SUCCESS_MESSAGE": "Lozinka je uspješno promijenjena.",
      "ERROR_MESSAGE": "Nije uspjelo spajanje na chat server. Molimo pokušajte ponovno."
    },
    "CAPTCHA": {
      "ERROR": "Potvrda istekla. Molimo ponovno riješite captcha."
    },
    "SUBMIT": "Pošalji"
  }
}
